import * as actionTypes from './actionTypes';

export const INITIAL_STATE = {
	components: [],
	pagination: {},
	componentsLoading: true,
	componentsError: null,
	componentTypes: [],
	componentTypesLoading: true,
	componentTypesError: null,
	savingApproval: false,
	savingApprovalError: null,
	componentTypeToApprove: null
};

/*
 * The two reads are independent and land on the same page, so each keeps its own loading and error
 * flag. Note that fetching either one spreads `...state` rather than `...INITIAL_STATE`: paging
 * the fleet table must not wipe the analytics rows, which the detail modal also reads to show a
 * component's fleet context.
 */
const hardwareInventoryReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case actionTypes.START_FETCHING_FLEET_COMPONENTS:
			return { ...state, componentsLoading: true, componentsError: null };
		case actionTypes.GET_FLEET_COMPONENTS_SUCCESS:
			return {
				...state,
				components: action.payload.components,
				pagination: action.payload.pagination,
				componentsLoading: false,
				componentsError: null
			};
		case actionTypes.GET_FLEET_COMPONENTS_ERROR:
			return { ...state, componentsLoading: false, componentsError: action.payload };

		case actionTypes.START_FETCHING_COMPONENT_TYPES:
			return { ...state, componentTypesLoading: true, componentTypesError: null };
		case actionTypes.GET_COMPONENT_TYPES_SUCCESS:
			return {
				...state,
				componentTypes: action.payload.componentTypes,
				componentTypesLoading: false,
				componentTypesError: null
			};
		case actionTypes.GET_COMPONENT_TYPES_ERROR:
			return { ...state, componentTypesLoading: false, componentTypesError: action.payload };

		/*
		 * `componentTypeToApprove` holds the row the modal is open for rather than a boolean: the
		 * modal needs the type's identity to scan the fleet for its versions, and the row carries
		 * the currently approved version the form starts from.
		 */
		case actionTypes.SHOW_COMPONENT_TYPE_APPROVAL_MODAL:
			return { ...state, componentTypeToApprove: action.payload, savingApprovalError: null };
		case actionTypes.HIDE_COMPONENT_TYPE_APPROVAL_MODAL:
			return { ...state, componentTypeToApprove: null };
		case actionTypes.START_SAVING_COMPONENT_TYPE_APPROVAL:
			return { ...state, savingApproval: true, savingApprovalError: null };
		case actionTypes.SAVE_COMPONENT_TYPE_APPROVAL_SUCCESS:
			return { ...state, savingApproval: false, savingApprovalError: null };
		case actionTypes.SAVE_COMPONENT_TYPE_APPROVAL_ERROR:
			return { ...state, savingApproval: false, savingApprovalError: action.payload };
		/*
		 * An abort is the page's own unmount cleanup, so nothing is reported - but the write still
		 * owns a raised `savingApproval` flag and an open modal, and this slice outlives the route.
		 * Without lowering both, the next visit opens with a stale dialog over disabled actions.
		 */
		case actionTypes.SAVE_COMPONENT_TYPE_APPROVAL_ABORTED:
			return {
				...state,
				savingApproval: false,
				savingApprovalError: null,
				componentTypeToApprove: null
			};

		default:
			return state;
	}
};

export default hardwareInventoryReducer;
